import React, { useState } from "react";
import ReactDOM from "react-dom";
import { Geography } from "react-simple-maps";
import { useTheme } from "@mui/material/styles";
import { useMaterialUIController } from "../../../context";

const POPUP_DARK_BG = "#1a1f2a";
const POPUP_DARK_TEXT = "#f1f5f9";
const POPUP_LIGHT_BG = "#ffffff";
const POPUP_LIGHT_TEXT = "#1a1a1a";

export default function GeographyComponent({ geo, fill, data, isDark, theme: themeProp }) {
  const muiTheme = useTheme();
  const theme = themeProp ?? muiTheme;
  const [controller] = useMaterialUIController();
  const darkMode = controller?.darkMode === true;
  const [show, setShow] = useState(false);
  const [pos, setPos] = useState({ x: 0, y: 0 });

  const users = Number(data?.Users ?? data?.users ?? data?.Count ?? data?.count ?? 0);
  const subscriptions = Number(data?.Subscriptions ?? data?.subscriptions ?? 0);

  const isPopupDark = darkMode || theme.palette.mode === "dark";
  const tooltipBg = isPopupDark ? POPUP_DARK_BG : POPUP_LIGHT_BG;
  const tooltipColor = isPopupDark ? POPUP_DARK_TEXT : POPUP_LIGHT_TEXT;
  const hoverFill = isPopupDark
    ? (theme.palette.primary?.light ?? "#c9a0c9")
    : "#b565c7";

  const tooltip = show ? (
    <div
      style={{
        position: "fixed",
        top: pos.y,
        left: pos.x,
        background: tooltipBg,
        color: tooltipColor,
        padding: "8px 10px",
        borderRadius: "6px",
        boxShadow: isPopupDark ? "0 2px 12px rgba(0,0,0,0.4)" : "0 2px 6px rgba(0,0,0,0.15)",
        border: isPopupDark ? "1px solid rgba(255,255,255,0.12)" : "1px solid rgba(0,0,0,0.08)",
        pointerEvents: "none",
        zIndex: 9999,
        fontSize: "13px",
      }}
    >
      <strong>{geo.properties.name}</strong>
      <br />
      Users: {users}
      <br />
      Subscriptions: {subscriptions}
    </div>
  ) : null;

  return (
    <>
      <Geography
        geography={geo}
        fill={fill}
        onMouseEnter={(e) => {
          setShow(true);
          setPos({ x: e.clientX + 12, y: e.clientY + 12 });
        }}
        onMouseLeave={() => setShow(false)}
        onMouseMove={(e) =>
          setPos({ x: e.clientX + 12, y: e.clientY + 12 })
        }
        style={{
          default: { outline: "none" },
          hover: { fill: hoverFill, outline: "none" },
          pressed: { outline: "none" },
        }}
      />

      {ReactDOM.createPortal(tooltip, document.body)}
    </>
  );
}
